import React from "react";
import { ApplicationForm } from "./ApplicationForm";
import { ApplicationFormSchema } from "components/templates/AddApplicationFormGroupModal/ApplicationForm";
import { CourseFromGroupApi } from "api";
import { PaziaModal } from "components/molecules";
import { ModalPadding } from "../Modals/ModalPadding";

interface AddApplicationFormGroupModalProps {
  onCloseRequest: () => void;
  onSubmit: (data: ApplicationFormSchema) => Promise<void>;
  group: CourseFromGroupApi | null;
}

export const AddApplicationFormGroupModal = ({
  onCloseRequest,
  group,
  onSubmit,
}: AddApplicationFormGroupModalProps) => {
  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={!!group} size="2xl">
      <ModalPadding>
        <div className="text-xl">
          <div className="mb-2 font-medium text-slate-800 dark:text-slate-100">
            {group?.courseFormGroupId ? "Edycja grupy" : "Dodaj nową grupę"}
          </div>
        </div>
        {group && <ApplicationForm group={group} onSubmit={onSubmit} onCancel={onCloseRequest} />}
      </ModalPadding>
    </PaziaModal>
  );
};
